import { useQuery } from 'react-query';
import api from '../config/api';

const BUILTIN_LABELS = {
  admin: 'Administrator',
  consultant: 'Consultant',
  candidate: 'Candidate',
  ticket_logger: 'Ticket logger (internal)',
  external_ticket_logger: 'Ticket logger (external)',
  external: 'External contact',
};

export function roleLabel(slug, roles = []) {
  const match = roles.find((r) => r.slug === slug);
  if (match?.label) return match.label;
  return BUILTIN_LABELS[slug] || slug;
}

/** Whether a role may sign in to the app (external contacts cannot). */
export function roleAllowsLogin(roleOrSlug, roles = []) {
  if (roleOrSlug && typeof roleOrSlug === 'object') {
    if (roleOrSlug.allows_login === false || roleOrSlug.allows_login === 0) return false;
    if (roleOrSlug.allows_login === true || roleOrSlug.allows_login === 1) return true;
    return roleOrSlug.slug !== 'external';
  }
  const slug = roleOrSlug;
  if (slug === 'external') return false;
  const match = roles.find((r) => r.slug === slug);
  if (match && match.allows_login !== undefined && match.allows_login !== null) {
    return Boolean(match.allows_login);
  }
  return true;
}

export function useAppRoles({ includeAll = false } = {}) {
  return useQuery(
    ['app-roles', includeAll ? 'all' : 'active'],
    () =>
      api
        .get('/roles', { params: includeAll ? { all: 1 } : {} })
        .then((res) => res.data),
    { staleTime: 5 * 60_000 }
  );
}
